// build-in library

import CardWrapper from '@/components/UI/CardWrapper';
import StatusWidget from '@/components/Widgets/StatusWidget';
import { useSelector } from 'react-redux';
//import TotalUnitsInDevelopments from "components/Widgets/TotalUnitsInDevelopmentWidget";
//import TotalForSaleUnitsWidget from "components/Widgets/TotalForSaleUnitsWidget";
//import TotalAffdForSaleUnitsWidget from "components/Widgets/TotalAffdForSaleUnitsWidgets";
//import TotalAffdRentalUnitsWidget from "components/Widgets/TotalAffdRentalUnitsWidget";
//import TotalMarketRentalUnits from "components/Widgets/TotalMarketRentalUnits";
//import AvgSalesPriceAffordableWidget from "components/Widgets/AvgSalesPriceAffordableWidget";
import CityInvestmentWidget from '@/components/Widgets/CityInvestmentWidget';
import DevelopersInvestmentWidget from '@/components/Widgets/DevelopersInvestmentWidget';
import DevelopmentPipelineWidget from '@/components/Widgets/DevelopmentPipelineWidget';
import DistrictImpactWidget from '@/components/Widgets/DistrictImpactWidget';
import NewConstructionSummary from '@/components/Widgets/NewConstructionSummaryWidget';
import ProgrammaticSummary from '@/components/Widgets/ProgrammaticSummaryWidget';
import TotalProgramsWidget from '@/components/Widgets/TotalProgramsWidget';
import TotalProjectSourcesWidget from '@/components/Widgets/TotalProjectSourcesWidget';
import TotalProjectUsesWidget from '@/components/Widgets/TotalProjectUsesWidget';
import { authSelector } from '@/store';
//Custom Components
import DashboardWidget from '../../../components/DashboardWidget';
import { HasPermission } from '@/components/Permission/HasPermission';
import ConstructionTypeWidget from '../../../components/Widgets/ConstructionTypeWidget';
import { DashboardName, Widget } from '@/components/Widgets/constants.tsx';
import NeighborhoodImpactWidget from '../../../components/Widgets/NeighborhoodImpactWidget';
import ProjectBudgetSummaryWidget from '../../../components/Widgets/ProjectBudgetSummaryWidget';
import ProjectLocationWidget from '../../../components/Widgets/ProjectLocationWidget';
import ProjectStatusSummaryWidget from '../../../components/Widgets/ProjectStatusSummaryWidget';
import ProjectTypeWidget from '../../../components/Widgets/ProjectTypeWidget';
import RebuildLoansApprovedWidget from '../../../components/Widgets/RebuildLoansApprovedWidget';
import TotalDevelopersWidget from '../../../components/Widgets/TotalDevelopersWidget';
import TotalProjectsWidget from '../../../components/Widgets/TotalProjectsWidget';
//Services
import { useDashboardWidgetsList } from '@/hooks/ReactQueryHooks/useDashboardQuery';

import { shouldRenderWidget } from './constants';

function SherpaDashboard({ showButton = true }: { showButton?: boolean }) {
  const { data } = useSelector(authSelector);
  const { isWidgetUsed } = useDashboardWidgetsList({
    dashboard: DashboardName.SHERPA_DASHBOARD,
  });

  return (
    <div className='flex flex-col mx-auto space-y-4'>
      <div className='-mt-8'>
        <HasPermission of='MANAGE_WIDGETS'>{showButton && <DashboardWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}</HasPermission>
      </div>

      {/*<section className='grid gap-6 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>*/}
      {/*    /!*<section className="grid grid-flow-col auto-cols-fr gap-4">*!/*/}
      {/*  {isWidgetUsed?.[Widget.REBUILD_LOANS_APPROVED] && shouldRenderWidget(Widget.REBUILD_LOANS_APPROVED, data?.account) && (*/}
      {/*    <RebuildLoansApprovedWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}
      {/*  {isWidgetUsed?.[Widget.TOTAL_DEVELOPERS] && shouldRenderWidget(Widget.TOTAL_DEVELOPERS, data?.account) && (*/}
      {/*    <TotalDevelopersWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}
      {/*  {(data?.account === 'birminghamhousing' ||*/}
      {/*    (shouldRenderWidget(Widget.TOTAL_PROGRAMS, data?.account) && isWidgetUsed?.[Widget.TOTAL_PROGRAMS])) && (*/}
      {/*    <TotalProgramsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}

      {/*  /!*Developer Pipeline*!/*/}
      {/*  {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (*/}
      {/*    <DevelopmentPipelineWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}

      {/*  /!*Developers Investment*!/*/}
      {/*  {shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (*/}
      {/*    <DevelopersInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}

      {/*  /!*City Investment*!/*/}
      {/*  {shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (*/}
      {/*    <CityInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}

      {/*  /!*Total Projects*!/*/}
      {/*  {isWidgetUsed?.[Widget.TOTAL_PROJECTS] && shouldRenderWidget(Widget.TOTAL_PROJECTS, data?.account) && (*/}
      {/*    <TotalProjectsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />*/}
      {/*  )}*/}
      {/*</section>*/}
      <section className='grid gap-6 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>
        {isWidgetUsed?.[Widget.REBUILD_LOANS_APPROVED] && shouldRenderWidget(Widget.REBUILD_LOANS_APPROVED, data?.account) && (
          <CardWrapper>
            <RebuildLoansApprovedWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.TOTAL_DEVELOPERS] && shouldRenderWidget(Widget.TOTAL_DEVELOPERS, data?.account) && (
          <CardWrapper>
            <TotalDevelopersWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {(data?.account === 'birminghamhousing' ||
          (shouldRenderWidget(Widget.TOTAL_PROGRAMS, data?.account) && isWidgetUsed?.[Widget.TOTAL_PROGRAMS])) && (
          <CardWrapper>
            <TotalProgramsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (
          <CardWrapper>
            <DevelopmentPipelineWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <CardWrapper>
            <DevelopersInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
          <CardWrapper>
            <CityInvestmentWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}

        {isWidgetUsed?.[Widget.TOTAL_PROJECTS] && shouldRenderWidget(Widget.TOTAL_PROJECTS, data?.account) && (
          <CardWrapper>
            <TotalProjectsWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </CardWrapper>
        )}
      </section>
      <div className='col-span-1 mt-8'>
        {shouldRenderWidget(Widget.PROGRAMMATIC_SUMMARY, data?.account) && (
          <ProgrammaticSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
        )}
      </div>
      <section className='flex flex-col mt-8'>
        {shouldRenderWidget(Widget.NEW_CONSTRUCTION_SUMMARY, data?.account) && (
          <div className='col-span-4 2xl:col-span-2'>
            <NewConstructionSummary dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-8 mt-4'>
          {isWidgetUsed?.[Widget.PROJECTS_BY_CONSTRUCTION_TYPE] &&
            shouldRenderWidget(Widget.PROJECTS_BY_CONSTRUCTION_TYPE, data?.account) && (
              <div className='lg:col-span-1'>
                <ConstructionTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
              </div>
            )}

          {isWidgetUsed?.[Widget.PROJECTS_BY_PROJECT_TYPE] && shouldRenderWidget(Widget.PROJECTS_BY_PROJECT_TYPE, data?.account) && (
            <div className='lg:col-span-1'>
              <ProjectTypeWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
            </div>
          )}
        </div>
        {shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD_DISTRICT, data?.account) && (
          <div className='lg:col-span-3 mt-8'>
            <DistrictImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}

        <div className='grid auto-rows-min items-start gap-8 mt-6 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>
          {/*Neighborhood Impact*/}
          {isWidgetUsed?.[Widget.PROJECTS_BY_NEIGHBORHOOD] && shouldRenderWidget(Widget.PROJECTS_BY_NEIGHBORHOOD, data?.account) && (
            <NeighborhoodImpactWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          )}

          {isWidgetUsed?.[Widget.PROJECT_STATUS_SUMMARY] && shouldRenderWidget(Widget.PROJECT_STATUS_SUMMARY, data?.account) && (
            <ProjectStatusSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          )}
        </div>

        {isWidgetUsed?.[Widget.PROJECT_LOCATION] && shouldRenderWidget(Widget.PROJECT_LOCATION, data?.account) && (
          <div className='flex-1 mt-6'>
            <ProjectLocationWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}
      </section>

      <section className='flex flex-col gap-4'>
        {/*<div className='grid gap-8 mt-6 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>*/}
        {/*  {isWidgetUsed?.[Widget.PROJECT_FINANCIAL] && shouldRenderWidget(Widget.PROJECT_FINANCIAL, data?.account) &&*/}
        {/*      (*/}
        {/*          <ProgramFinancialWidget dashboard={DashboardName.SHERPA_DASHBOARD}/>*/}
        {/*      )}*/}
        {/*</div>*/}

        {shouldRenderWidget(Widget.PROJECTS_SUMMARY_REPORT, data?.account) && (
          <div className='flex'>
            <StatusWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          </div>
        )}

        {shouldRenderWidget(Widget.PROJECT_BUDGET_SUMMARY, data?.account) && (
          <div className='flex-1 mt-8'>
            {isWidgetUsed?.[Widget.PROJECT_BUDGET_SUMMARY] && <ProjectBudgetSummaryWidget dashboard={DashboardName.SHERPA_DASHBOARD} />}
          </div>
        )}
        <div className='grid gap-8 mt-8 grid-cols-[repeat(auto-fit,minmax(350px,1fr))]'>
          {isWidgetUsed?.[Widget.PROJECTS_BY_SOURCES] && shouldRenderWidget(Widget.PROJECTS_BY_SOURCES, data?.account) && (
            <TotalProjectSourcesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          )}
          {shouldRenderWidget(Widget.PROJECTS_BY_USES, data?.account) && (
            <TotalProjectUsesWidget dashboard={DashboardName.SHERPA_DASHBOARD} />
          )}
        </div>
      </section>
    </div>
  );
}

export default SherpaDashboard;
